import { render, staticRenderFns } from "./AddEditNewQuestionnaire.vue?vue&type=template&id=5618ed9e&scoped=true&"
import script from "./AddEditNewQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./AddEditNewQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./AddEditNewQuestionnaire.vue?vue&type=style&index=0&id=5618ed9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618ed9e",
  null
  
)

export default component.exports